import {
	default as React,
	type ReactNode,
	createContext,
	useContext,
} from "react";
import { useComplexState } from "use-complex-state";
import { ShiftsCrewsReducer } from "../reducers/ShiftsCrewsReducer";

const ShiftsCrewsContext = createContext({
	state: ShiftsCrewsReducer.getInitialState(),
	actions: ShiftsCrewsReducer.actions,
});

export const useShiftsCrewsContext = () => useContext(ShiftsCrewsContext);

export const ShiftsCrewsProvider = ({ children }: { children: ReactNode }) => {
	const [state, actions] = useComplexState({
		initialState: ShiftsCrewsReducer.getInitialState(),
		reducers: ShiftsCrewsReducer.caseReducers,
	});

	return (
		<ShiftsCrewsContext.Provider value={{ state, actions }}>
			{children}
		</ShiftsCrewsContext.Provider>
	);
};
